import { render, staticRenderFns } from "./AlSidebar.vue?vue&type=template&id=27c5a2df&"
import script from "./AlSidebar.vue?vue&type=script&lang=js&"
export * from "./AlSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AlSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports